<!-- TODO: This template has become too complex. Look into refactoring it. -->
<div class="header">
	@if (relationshipName() && !alwaysShowLeftText()) {
		<button class="name" (click)="editRelationship()" [class.hidden]="!open()" [matTooltip]="`Edit ${modelName()}`" mat-button><span class="name-text">{{relationshipName()}}</span></button>
	}
	@if (alwaysShowLeftText()) {
		<span class="spacer" [class.hidden]="!open()"></span>
	}
	@if (collapsedLeftText() || collapsedRightText()) {
		<div class="collapsed-header" [class.expand-left-text]="alwaysShowInteractionOwner()">
			@if (relationship() || alwaysShowInteractionOwner()) {
				<button class="collapsed-left-text" [class.hidden]="open() && !alwaysShowLeftText()" [style]="open() ? {width: 'auto'} : {}" mat-button (click)="editRelationship()" [aria-label]="`Edit ${collapsedLeftText()}`">{{collapsedLeftText()}}</button>
			} @else {
				<span class="collapsed-left-text" [class.hidden]="open() && !alwaysShowLeftText()" [style]="open() ? {width: 'auto'} : {}">{{collapsedLeftText()}}</span>
			}
			@if (collapsedRightIcon()) {
				<mat-icon class="collapsed-right-icon" [class.hidden]="open()">{{collapsedRightIcon()}}</mat-icon>
			}
			@if (relationship()) {
				<span class="collapsed-right-text-prefix" [class.hidden]="open()">Last contact:</span>
			}
			<span class="collapsed-right-text" [class.hidden]="open()" [style.color]="relationship()?.attentionStatusColor || 'inherit'" [innerHTML]="collapsedRightText()"></span>
		</div>
	}

	<button class="edit" (click)="edit()" [class.hidden]="!open()" [matTooltip]="`Edit ${modelName()}`" mat-icon-button [aria-label]="`Edit ${modelName()}`" type="button">
		<mat-icon>edit</mat-icon>
	</button>
	<button class="delete" (click)="delete()" [class.hidden]="!open()" [matTooltip]="`Delete ${modelName()}`" mat-icon-button [aria-label]="`Delete ${modelName()}`" type="button">
		<mat-icon>delete</mat-icon>
	</button>
	@if (collapsible()) {
		@let collapseExpandText = `${(open() ? 'Collapse' : 'Expand')} ${modelName()}`;
		<button class="collapse-expand" (click)="toggleCollapseExpand()" [matTooltip]="collapseExpandText" mat-icon-button [aria-label]="collapseExpandText" type="button">
			<mat-icon [class.open]="open()">chevron_right</mat-icon>
		</button>
	}
</div>

<app-dynamic-scrollable class="body" [scrollable]="scrollableBody()" [is-visible]="open()" [style.display]="scrollableBody() ? 'block' : 'grid'">
	<ng-content />
</app-dynamic-scrollable>

@if (!hideFooter() && relationship()) {
	<div class="footer">
		@if (relationship()!.attentionNeededText) {
			<span>Attention needed:</span>
			<span [style.color]="relationship()!.attentionStatusColor" style="font-style: italic">{{relationship()!.attentionNeededText}}</span>
		} @else {
			<span>&nbsp;</span>
		}
	</div>
}
